import { render } from "./HistoryPush.vue?vue&type=template&id=506d90e6"
import script from "./HistoryPush.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryPush.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/components/registrationSubscription/HistoryPush.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "506d90e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('506d90e6', __exports__)) {
    console.log('reload')
    api.reload('506d90e6', __exports__)
  }
  
  module.hot.accept("./HistoryPush.vue?vue&type=template&id=506d90e6", () => {
    console.log('re-render')
    api.rerender('506d90e6', render)
  })

}


export default __exports__